<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.5 20.08496">
		<path fill="currentColor" d="M10.75 20.085a1.74572 1.74572 0 0 1-1.2373-.51172l-3-3A.2507.2507 0 0 0 6.33594 16.5H1.75A1.75213 1.75213 0 0 1 0 14.75v-13A1.75213 1.75213 0 0 1 1.75 0h18a1.75213 1.75213 0 0 1 1.75 1.75v13a1.75213 1.75213 0 0 1-1.75 1.75h-4.58594a.25156.25156 0 0 0-.17676.07324l-3 3a1.74572 1.74572 0 0 1-1.2373.51176ZM1.75 1.5a.25048.25048 0 0 0-.25.25v13a.25048.25048 0 0 0 .25.25h4.58594a1.7365 1.7365 0 0 1 1.2373.5127l3 3a.24993.24993 0 0 0 .35352 0l3-3A1.76037 1.76037 0 0 1 15.16406 15H19.75a.25048.25048 0 0 0 .25-.25v-13a.25048.25048 0 0 0-.25-.25Z"/>
		<g>
			<path d="M16 7.5H5.5a.75.75 0 0 1 0-1.5H16a.75.75 0 0 1 0 1.5Z"/>
			<path d="M12 11.5H5.5a.75.75 0 0 1 0-1.5H12a.75.75 0 0 1 0 1.5Z"/>
		</g>
	</svg>
</template>
